import { render, staticRenderFns } from "./teamPerformancePersonDetail.vue?vue&type=template&id=74bac852&scoped=true&"
import script from "./teamPerformancePersonDetail.vue?vue&type=script&lang=js&"
export * from "./teamPerformancePersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./teamPerformancePersonDetail.vue?vue&type=style&index=0&id=74bac852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bac852",
  null
  
)

export default component.exports